// For events that happen right before a full page load (e.g. a sign in that continues on an Unpoly page): pushed
// there, they would go down with the page before GTM, Amplitude and the pixels have sent them. They are pushed by the
// next page instead, after its page.view.

import { trackEvent, type TrackEventOverrides } from '../util/analytics'
import type { EventData } from './index'

const STORAGE_KEY = 'studyflix:tracking:next-page'

interface PendingEvent {
  event: string
  data: EventData
  overrides?: TrackEventOverrides
}

export function trackOnNextPage(
  event: string,
  data: EventData = {},
  { overrides }: { overrides?: TrackEventOverrides } = {},
): void {
  try {
    const pending = [...readPending(), { event, data, overrides }]
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(pending))
  } catch {
    trackEvent(event, data, { overrides })
  }
}

/** Call right after a page's page.view. */
export function flushNextPageEvents(): void {
  let pending: PendingEvent[]
  try {
    pending = readPending()
    window.sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    return
  }

  for (const { event, data, overrides } of pending) {
    trackEvent(event, data, { overrides })
  }
}

function readPending(): PendingEvent[] {
  const raw = window.sessionStorage.getItem(STORAGE_KEY)
  if (!raw) return []

  try {
    const parsed: unknown = JSON.parse(raw)
    return Array.isArray(parsed) ? (parsed as PendingEvent[]) : []
  } catch {
    return []
  }
}
